// eslint-disable-next-line import/no-cycle
import { IFile } from 'types/file';

/* eslint-disable import/no-cycle */
import { IAssignment } from './appointmentAssignments';
import { IChatRoom } from './messages';
import { IAddress, ITransaction } from './transaction';
import { IUser } from './user';

export interface ID {
  id: string;
}

export enum AppointmentNotaryType {
  IN_PERSON = 'IN_PERSON',
  RON = 'RON', // run on network
}

export const AppointmentNotaryTypeDisplay = {
  [AppointmentNotaryType.IN_PERSON]: 'In Person',
  [AppointmentNotaryType.RON]: 'RON',
};

export enum AppointmentStatus {
  OPEN = 'OPEN',
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}
export enum DocumentStatus {
  NONE = 'NONE',
  MAILED = 'MAILED',
  SCANNED = 'SCANNED',
}

export interface IAppointmentFields {
  type: AppointmentNotaryType;
  signatoryIds: string[];
  date: string;
  address: IAddress;
  duration?: number;
  notary?: IUser;
  assignments?: IAssignment[];
  transaction?: ITransaction;
  clientInPersonFee?: number;
  clientRONFee?: number;
  notaryGetInPerson?: number;
  notaryGetRON?: number;
  status?: AppointmentStatus;
  files?: IFile[];
  // only for when connecting appointment with files
  fileIds?: string[];
  // =======
  distance?: number;
  description?: string;
  chatRoom?: IChatRoom;
  isShippingLabelAutogenerated?: boolean;
  documentStatus?: DocumentStatus;
  scannedFiles?: IFile[];
  labelFiles?: IFile[];
  autoGenShippingLabel?: boolean;
  shippingOptions?: {
    serviceType: ShippingServiceType;
  };
}

export interface IAppointment extends IAppointmentFields, ID {}

export interface IAppointmentState extends IAppointmentFields, Partial<ID> {
  key?: string;
}

export enum ShippingServiceType {
  PRIORITY_OVERNIGHT = 'Priority Overnight',
  STANDARD_OVERNIGHT = 'Standard Overnight',
  FEDEX_2_DAY = '2nd Day Air',
  FEDEX_GROUND = 'Ground',
}
